/**
 * Entitlement-aware empty state. The backend gates every /api/agentic/*
 * endpoint with require_features_or_404(agentic_platform) — unentitled
 * tenants receive 404 (retain-and-hide) and permission-denied users 403.
 * Both render this clean state; never a crash or blank screen.
 */
import { Lock } from 'lucide-react';
import { EmptyState, Icon } from '@smms/design-system';

export default function NotEnabled() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-8" data-testid="not-enabled">
      <EmptyState
        variant="permission-denied"
        icon={<Icon as={Lock} size="lg" />}
        title="Agentic Operations isn't enabled for your tenant"
        description="Ask your SMMS account owner about enabling the agentic platform, or contact support if you believe you should have access."
      />
    </div>
  );
}
